export { HeroCard as Hero } from "./HeroCard";

export * from "./TextHero";
